import React, { ReactNode } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import NextLink from '../../common/next-link/NextLink';

import styles from './AuthLayout.module.scss';

type AuthLayoutProps = {
  children: ReactNode;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => (
  <div className={styles.mainWrapper}>
    <div className={styles.imageWrapper}>
      <Image
        className="absolute inset-0 h-full w-full object-cover"
        src="/images/background-auth.png"
        alt="Asian food background image"
        loading="eager"
        quality={50}
        layout="fill"
      />
    </div>

    <div className={styles.contentWrapper}>
      <Link href="/">
        <a className={styles.contentLogo} aria-label="Homepage">
          <Image
            src="/images/ktown-logo-red.svg"
            alt="Ktown logo"
            layout="fixed"
            loading="eager"
            height={26}
            width={124}
          />
        </a>
      </Link>

      <div className={styles.contentCenter} data-testid="authLayout-content">
        {children}
      </div>

      <p className={styles.contentFooter}>
        This site is protected by reCAPTCHA and the Google
        <br />
        <NextLink href="#">Privacy Policy</NextLink> and{' '}
        <NextLink href="#">Terms of Service</NextLink> apply
      </p>
    </div>
  </div>
);

export default AuthLayout;
